var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDownLarge4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.21786 6.2561L2.87695 7.59701L10.377 15.097L17.877 7.59701L16.536 6.2561L10.377 12.4152L4.21786 6.2561Z",
    fill: "#9095A1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDownLarge4);
export default __webpack_public_path__ + "static/media/chevron-down-large-4.a6056af9068091ce69c26b1e3d8ef449.svg";
export { ForwardRef as ReactComponent };